import { IoTDeviceDirection, IotDeviceFunction, IotOutput, SublocationWithDevices } from '@leid/api-locations'

import { DeviceDirection } from '../components/pickupReturnFlow/models'

export const getDoorsWithDirection = (
  direction: DeviceDirection,
  devices: SublocationWithDevices[],
): { sublocationId: number; outputs: IotOutput[] }[] => {
  const filteredDoors: { sublocationId: number; outputs: IotOutput[] }[] = []

  const targetDirection = direction === DeviceDirection.IN ? IoTDeviceDirection.IN : IoTDeviceDirection.OUT

  for (const sublocationData of devices) {
    const doorDevices = sublocationData.devices.filter((s) => s.function === IotDeviceFunction.DOOR)
    for (const door of doorDevices) {
      const outputs = door.outputs.filter(
        (s) =>
          (s.direction === targetDirection || s.direction === IoTDeviceDirection.BOTH) &&
          s.allowedToTriggerFromEcommerce === true,
      )

      if (outputs.length !== 0) {
        filteredDoors.push({
          sublocationId: sublocationData.sublocationId,
          outputs: outputs,
        })
      }
    }
  }

  return filteredDoors
}

export const getDoorsWithDirectionForSublocation = (
  direction: DeviceDirection,
  sublocationData: SublocationWithDevices,
): { sublocationId: number; outputs: IotOutput[] }[] => {
  const filteredDoors: { sublocationId: number; outputs: IotOutput[] }[] = []

  const targetDirection = direction === DeviceDirection.IN ? IoTDeviceDirection.IN : IoTDeviceDirection.OUT

  const doorDevices = sublocationData.devices.filter((s) => s.function === IotDeviceFunction.DOOR)
  for (const door of doorDevices) {
    const outputs = door.outputs.filter(
      (s) =>
        (s.direction === targetDirection || s.direction === IoTDeviceDirection.BOTH) &&
        s.allowedToTriggerFromEcommerce === true,
    )

    if (outputs.length !== 0) {
      filteredDoors.push({
        sublocationId: sublocationData.sublocationId,
        outputs: outputs,
      })
    }
  }

  return filteredDoors
}

export const getPINCodeDates = () => {
  const now = new Date()
  const startDate = new Date(now)
  startDate.setMinutes(0, 0, 0)

  const endDate = new Date(startDate)

  if (now.getMinutes() <= 30) {
    endDate.setHours(endDate.getHours() + 1)
  } else {
    endDate.setHours(endDate.getHours() + 2)
  }

  return { startDate, endDate }
}

export const toPrettifiedPin = (pinCode: string): string => {
  const prettified = pinCode?.replace(/(.{3})/g, '$1 ').trim()
  return prettified
}
